import { Pipe, PipeTransform } from '@angular/core';
import { WorkScheduleHoursInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-hours.dto';

const daysOfWeek: Record<keyof WorkScheduleHoursInterface, string> = {
  monday: 'Понедельник',
  tuesday: 'Вторник',
  wednesday: 'Среда',
  thursday: 'Четверг',
  friday: 'Пятница',
  saturday: 'Суббота',
  sunday: 'Воскресенье'
};

@Pipe({
  standalone: true,
  name: 'translateWeekDays'
})
export class TranslateWeekDaysPipe implements PipeTransform {
  public transform(key: string): number {
    return daysOfWeek[key];
  }
}
